import { AfterViewInit, Component, Injector, OnInit, ViewChild} from '@angular/core';
import {DialogBaseComponent} from "../../../admin-panel/base-admin-panel/dialog-base/dialog-base.component";
import { MapObject, SimpleMapComponent } from "../simple-map/c.component";

@Component({
    selector: 'app-map-dialog',
    templateUrl: './map-dialog.component.html',
    styleUrls: ['./map-dialog.component.css'],
    standalone: false
})
export class MapDialogComponent extends DialogBaseComponent<any> implements OnInit, AfterViewInit {
  @ViewChild(SimpleMapComponent, { static: true }) map: SimpleMapComponent;

  mapObjects: Array<MapObject> = null;
  public points = null;

  constructor(protected injector: Injector) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewInit() {
    this.ShowObjects(this.mapObjects);
  }

  public ShowObjects(objects: Array<MapObject>)
  {
    this.mapObjects = objects;
    if (this.map)
      this.map.ShowObjects(this.mapObjects, true);
  }
}
